import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";
import {plural, DatetoHtml, PassangersLine, VehiclesLine} from './functions'
import {updateSettings} from '../../routers/settings'

class headerSelection extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  onClick = (index) => {
    //window.scrollTo(0, 300)
    const lang = this.context.router.route.location.pathname.split('/')[1]
    //this.props.updateSettings({tab: index})
    window.location.href = `/${lang}`
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].fastbooking.tabs
    const langPassengers = languages[langUrl].fastbooking.passengers
    const langVehicles = languages[langUrl].fastbooking.vehicles
    const langCalendar = languages[langUrl].fastbooking.calendar

    const {travels} = this.props.settings
    const {calcDeparture, calcReturn} = this.props.settings

    const {travel, origin, destiny} = this.props.values
    const {nAdults, nKids, nBabies, nTeens} = this.props.values
    const {nCars, nMotorcycles, nVans, nBikes, nTowing} = this.props.values
    const {departuredate, returndate} = this.props.values

    const nPass = nAdults + nTeens + nKids + nBabies
    const nVeh = nCars + nMotorcycles + nVans + nBikes + nTowing

    const passangers = nPass + ' ' + plural(nPass, langPlace.passengers)
    const vehicles = nVeh + ' ' + plural(nVeh, langPlace.vehicles)

    const total = calcDeparture.price + ((travel === 0) ? calcReturn.price: 0)

    const originName = (destiny !== undefined)? travels[origin].name: ''
    const destinyName = (destiny !== undefined)? travels[origin].destinations[destiny].name: ''

    const classValue = (travel === 0)? 'col-md-6 col-sm-6 col-xs-6 button': 'col-md-12 col-sm-12 col-xs-6 button'

    return (
      <div className='row header-selection'>
        <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
          <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12 button' onClick={() => this.onClick(0)}>
            <div>
              <div className='title'><i className="fa fa-ship icon" aria-hidden="true"/>{(travel===0)?langPlace.roundtrip: langPlace.going}</div>
                <div className='subtitle'>{`${originName} - ${destinyName}`}</div>
            </div>
          </div>
          <div className='col-md-2 col-sm-3 col-xs-6 button' onClick={() => this.onClick(1)}>
            <div>
              <div className='title'><i className="fa fa-users icon" aria-hidden="true"/>{passangers}</div>
              <div className='subtitle'>{PassangersLine(this.props.values, langPassengers)}</div>
            </div>
          </div>
          <div className='col-md-2 col-sm-3 col-xs-6 button' onClick={() => this.onClick(2)}>
            <div>
              <div className='title'><i className="fa fa-car icon" aria-hidden="true"/>{vehicles}</div>
              <div className='subtitle'>{VehiclesLine(this.props.values, langVehicles)}</div>
            </div>
          </div>
          <div className='col-lg-3 col-md-3 col-sm-6 col-xs-6'>
            <div className='row'>
              <div className={classValue} onClick={() => this.onClick(3)}>
                <div>
                  <div className='title'><i className="fa fa-calendar icon" aria-hidden="true"/>{langPlace.going}</div>
                  <div className='subtitle'>{DatetoHtml(departuredate, undefined, langCalendar)}</div>
                </div>
              </div>
              {(travel === 0)?
                <div className='col-md-6 col-sm-6 col-xs-6 button' onClick={() => this.onClick(4)}>
                  <div>
                    <div className='title'><i className="fa fa-calendar icon" aria-hidden="true"/>{langPlace.return}</div>
                    <div className='subtitle'>{DatetoHtml(returndate, undefined, langCalendar)}</div>
                  </div>
                </div>
              : undefined}
            </div>
          </div>
          <div className='col-md-2 col-sm-6 col-xs-6 button total'>
            <div>
              {total.toLocaleString('es-ES',{minimumFractionDigits: 2})} €
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
	(state) => ({settings: state.settings, values: state.data.values}),
  {updateSettings}
)(headerSelection)



// WEBPACK FOOTER //
// ./src/shared/routes/components/headerSelection.js